import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyBoolean } from "../../RadObject";
import { ContainerControl, ContainerControlPropertyValues, IContainerControl } from "./ContainerControl";
import { NAMESPACE } from "./_Namespace";

import "./CardList.scss";

export type CardListPropertyValues =
    ContainerControlPropertyValues
    & {
        stackable: boolean;
    };

export type CardListProperties = {
    [name in keyof CardListPropertyValues]: Property<CardListPropertyValues[name]>
};

export interface ICardList extends IContainerControl, CardListProperties
{
}

export class CardList extends ContainerControl implements ICardList
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CardList";
    public static override className = "CardList";

    // #endregion

    // #region Instance

    // #region Properties

    public stackable!: PropertyBoolean;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CardListPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-card-list ui cards");

        // Trigger Property Changes
        this.stackable.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _stackableChanged(change: PropertyChange<boolean>)
    {
        if (change.currentValue)
            this.addCssClass("stackable");
        else
            this.removeCssClass("stackable");
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: CardListPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.stackable = new PropertyBoolean(this, propertyValues.stackable, this._stackableChanged);
    }

    // #endregion

    // #endregion
}